export const UPDATE_AUTOSUGGEST_VALUE = 'UPDATE_AUTOSUGGEST_VALUE';
export const UPDATE_AUTOSUGGEST_SUGGESTIONS = 'UPDATE_AUTOSUGGEST_SUGGESTIONS';

export const updateAutosuggestValue = (id, value) => {
  return {
    type: UPDATE_AUTOSUGGEST_VALUE,
    id,
    value,
  };
};

export const updateAutosuggestSuggestions = (id, suggestions) => {
  return {
    type: UPDATE_AUTOSUGGEST_SUGGESTIONS,
    id,
    suggestions,
  };
};
